import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Row, Col } from 'react-bootstrap';
import { apiRequests } from '../../shared/api/apiRequests';
import { toast } from 'react-toastify';
import { FormLayout, FormSection, FormField, FormLoading } from '../../shared/ui/FormLayout';

const EditDocument = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [formData, setFormData] = useState({
    id: 0,
    number: '',
    date: '',
    customerName: '',
    companyName: '',
    details: '',
    customerId: '',
  });

  useEffect(() => {
    loadDocument();
  }, [id]);

  const loadDocument = async () => {
    try {
      setLoadingData(true);
      const response = await apiRequests.documents.getById(id);
      setFormData({
        id: response.id,
        number: response.number,
        date: response.date.split('T')[0],
        customerName: response.customerName,
        companyName: response.companyName || '',
        details: response.details || '',
        customerId: response.customerId || '',
      });
    } catch (e) {
      console.error('Ошибка загрузки документа:', e);
      toast.error('Ошибка загрузки документа');
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.number || !formData.customerName) {
      toast.error('Заполните обязательные поля');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...formData,
        customerId: formData.customerId ? parseInt(formData.customerId) : null,
      };
      await apiRequests.documents.update(payload);
      toast.success('Документ обновлен');
      navigate('/documents');
    } catch (e) {
      console.error('Ошибка обновления документа:', e);
      toast.error('Ошибка при обновлении документа');
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) return <FormLoading />;

  return (
    <FormLayout
      onSubmit={handleSubmit}
      onBack={() => navigate('/documents')}
      saving={loading}
      submitText="Сохранить"
      savingText="Сохранение..."
    >
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Номер документа" required>
              <Form.Control
                type="text"
                name="number"
                value={formData.number}
                onChange={handleChange}
                placeholder="Введите номер документа"
              />
            </FormField>
          </Col>
          <Col md={6}>
            <FormField label="Дата" required>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </FormField>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormField label="Имя клиента" required>
              <Form.Control
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                placeholder="Введите имя клиента"
              />
            </FormField>
          </Col>
          <Col md={6}>
            <FormField label="Название компании">
              <Form.Control
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Опционально"
              />
            </FormField>
          </Col>
        </Row>

        <FormField label="ID клиента" hint="Укажите ID пользователя для привязки документа к клиенту">
          <Form.Control
            type="number"
            name="customerId"
            value={formData.customerId}
            onChange={handleChange}
            placeholder="Опционально"
            style={{ maxWidth: '200px' }}
          />
        </FormField>

        <FormField label="Детали">
          <Form.Control
            as="textarea"
            rows={4}
            name="details"
            value={formData.details}
            onChange={handleChange}
            placeholder="Введите дополнительные детали"
          />
        </FormField>
      </FormSection>
    </FormLayout>
  );
};

export default EditDocument;
